import TokenService from './TokenService'
import Client from "./Client";

const AccountService = {
    url : 'panel/account',
    signOut() {
        TokenService.removeToken();
    },
    async getSubscription(){
        return await Client.get(`${this.url}/subscription`);
    }
}

export default AccountService